import React, { useEffect, useState } from 'react'
import { Table, message, Tag, Button, Tooltip } from 'antd'
import { sendHttpPostRequest } from '../../../api/http-request'

interface Props {}

export const MyPurchasedProjects: React.FC<Props> = () => {
  const [list, setList] = useState([] as any[])
  const [loading, setLoading] = useState(false)

  const renderNoWrapText = (text: any, width: number, fontWeight = 400) => {
    const value = text || '-'
    return (
      <Tooltip title={String(value)}>
        <span
          style={{
            display: 'inline-block',
            width,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            verticalAlign: 'middle',
            fontWeight,
          }}
        >
          {value}
        </span>
      </Tooltip>
    )
  }

  const queryPurchasedProjects = () => {
    setLoading(true)
    sendHttpPostRequest('account/api/query_my_purchased_projects', {}, (res: any) => {
      setLoading(false)
      if (res.code == -100) {
        document.getElementById('show-login-modal')?.click()
      } else if (res.is_ok) {
        setList(res?.data?.list || [])
      } else {
        message.error(res?.message || '查询已购项目失败')
      }
    })
  }

  useEffect(() => {
    queryPurchasedProjects()
  }, [])

  const getStatusColor = (status: number) => {
    if (status == 2) {
      return 'green'
    }
    if (status == 3) {
      return 'orange'
    }
    if (status == 4) {
      return 'default'
    }
    return 'blue'
  }

  const columns = [
    {
      title: '项目名称',
      dataIndex: 'course_name',
      key: 'course_name',
      width: 260,
      ellipsis: true,
      render: (text: string) => renderNoWrapText(text, 240, 500),
    },
    {
      title: '购买时间',
      dataIndex: 'purchase_time',
      key: 'purchase_time',
      width: 190,
      ellipsis: true,
      render: (text: string) => renderNoWrapText(text, 170),
    },
    {
      title: '生效时间',
      dataIndex: 'start_date',
      key: 'start_date',
      width: 140,
      ellipsis: true,
      render: (text: string) => renderNoWrapText(text, 120),
    },
    {
      title: '过期时间',
      dataIndex: 'end_date',
      key: 'end_date',
      width: 140,
      ellipsis: true,
      render: (text: string) => renderNoWrapText(text, 120),
    },
    {
      title: '购买价格',
      dataIndex: 'amount_yuan',
      key: 'amount_yuan',
      width: 120,
      ellipsis: true,
      render: (text: string) => renderNoWrapText(`￥${text || '0.00'}`, 100),
    },
    {
      title: '状态',
      dataIndex: 'status_text',
      key: 'status_text',
      width: 100,
      ellipsis: true,
      render: (_text: string, record: any) => (
        <Tag color={getStatusColor(record?.status)}>{record?.status_text || '-'}</Tag>
      ),
    },
    {
      title: '操作',
      key: 'action',
      width: 110,
      fixed: 'right' as const,
      render: (_: any, record: any) => {
        const active = record?.status == 2
        return (
          <Tooltip title={active ? '' : '订阅未生效或已过期'}>
            <Button
              size="small"
              type="primary"
              disabled={!active || !record?.course_id}
              onClick={() => {
                window.open('/project_main_student?project_id=' + record.course_id)
              }}
            >
              进入项目
            </Button>
          </Tooltip>
        )
      },
    },
  ]

  return (
    <div>
      <div style={{ fontSize: 20, fontWeight: 700, color: '#111827', marginBottom: 8 }}>
        已购项目
      </div>
      <div style={{ color: '#6b7280', fontSize: 13, marginBottom: 18 }}>
        查看个人已购项目的购买时间、服务期及价格信息，订阅生效期间可直接进入。
      </div>
      <Table
        rowKey={(record: any) => `${record.order_no || ''}-${record.course_id || ''}-${record.purchase_time || ''}`}
        loading={loading}
        columns={columns}
        dataSource={list}
        size="middle"
        pagination={{
          pageSize: 8,
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
        scroll={{ x: 1080 }}
        rowClassName={(record: any) =>
          record?.status == 2 ? '' : 'ant-table-row-disabled'
        }
        style={{ borderRadius: 10, overflow: 'hidden', background: '#fff' }}
      />
    </div>
  )
}

export default MyPurchasedProjects
